import React from 'react'
import { v4 as uuidv4 } from 'uuid';
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import Translation from '../../Translation/cont/Translation'
import { EDIT_PRINT_CAP } from '../../../constants/caps'
import ImageDisplayAndUpload from '../../forms/fields/ImageDisplayAndUpload'
import FieldWrapper from '../../forms/FieldWrapper'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import ButtonSubmitCancel from '../../general/ButtonSubmitCancel'
import { sanitizeFormInput, sanitizeFormOutput } from '../../../functions/formFunctions'
import WrapperAccordion from '../../general/WrapperAccordion';
import { withRouter } from 'react-router-dom';
import { TextEditor } from '../../forms/fields/TextEditor';
import printConfig from '../../../print-config.json'

const EditNewspaper = ({itemData, onUpdateItem, history, closePagePath, itemType}) => {
    const pageName = itemType ? [<Translation key="type" id={printConfig.routes[itemType].transIdname}/>, <Translation key="edit" id="print_flyer_edit" before=" "/>] : ''

    return (
        <WrapperPageSimple pageTitle={pageName} closePagePath={closePagePath}>
            <div className="program-page flyer site-content">
                {itemData && itemData.newspaperAnnouncementSettings ? (
                    <Formik
                        initialValues={sanitizeFormInput(itemData.newspaperAnnouncementSettings)}
                        onSubmit={(values, actions) => {
                            onUpdateItem(sanitizeFormOutput(values))
                            history.push(closePagePath)
                        }}
                        
                        onReset={(values, actions) => {
                            history.push(closePagePath)
                        }}
                    >
                    {({ values, errors, status, touched, isSubmitting, handleReset, setFieldValue }) => (
                            <Form>
                                <WrapperAccordion
                                    className="single-section"
                                    selectionActiveClass="accordion-item-open"
                                >
                                    <fieldset>
                                        <div className="form-content flyer">
                                            <div className="left-sections">
                                                  <FieldWrapper label={<Translation id="print_newspaper_textInTopPart"/>} id="textInTopPart" classes="field-textarea field-textarea-text">
                                                    <TextEditor
                                                        setFieldValue={(val) => setFieldValue("textInTopPart", val)}
                                                        value={values.textInTopPart}
                                                    />
                                                    <ErrorMessage className="text-regular-color" name="textInTopPart" component="div" /> 
                                                </FieldWrapper>
                                                <FieldWrapper classes="image field-text" label={<Translation id="logo"/>} id="logo" >
                                                    <Field 
                                                        name="logo"
                                                        component={ImageDisplayAndUpload}
                                                    />
                                                </FieldWrapper>
                                                 <FieldWrapper label={<Translation id="style_newsletterBackground"/>} id="background" classes="field-text">
                                                    <Field type="text" name="background" id="background" className="text-regular input-text-box" />
                                                    <ErrorMessage className="text-regular-color" name="background" component="div" /> 
                                                </FieldWrapper>
                                                 <FieldWrapper label={<Translation id="print_flyer_text_color"/>} id="color" classes="field-text">
                                                    <Field type="text" name="color" id="color" className="text-regular input-text-box" />
                                                    <ErrorMessage className="text-regular-color" name="color" component="div" /> 
                                                </FieldWrapper>
                                                <div className='field-text'>
                                                    <label>
                                                        <p className='gap-10'><Translation id="print_newspaper_showQRCode">QR-Code im oberen Bereich anzeigen</Translation></p>
                                                    
                                                        <Field type="checkbox" checked={values.showQRCode} id="active-title-top-text" className="checkbox tgl tgl-flat" onChange={() => {
                                                            setFieldValue('showQRCode', !values.showQRCode)
                                                        }}/>
                                                        <span className="tgl-btn text-regular"><span className='screen-reader-text'><Translation id="print_flyer_activate_customization">Aktiv</Translation></span></span>
                                                    </label>
                                                </div>
                                                <div className='field-text'>
                                                    <label>
                                                        <p className='gap-10'><Translation id="print_newspaper_hideUrlInTopPart">Kino-URL im oberen Bereich ausblenden</Translation></p>
                                                    
                                                        <Field type="checkbox" checked={values.hideUrlInTopPart} id="active-title-top-text" className="checkbox tgl tgl-flat" onChange={() => {
                                                            setFieldValue('hideUrlInTopPart', !values.hideUrlInTopPart)
                                                        }}/>
                                                        <span className="tgl-btn text-regular"><span className='screen-reader-text'><Translation id="print_flyer_activate_customization">Aktiv</Translation></span></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                    
                                        <ButtonSubmitCancel
                                            transIdCancel="cancel_button"
                                            transIdSubmit="save_item_button"
                                            cap={EDIT_PRINT_CAP}
                                            disabledCancel={isSubmitting}
                                            disabledSubmit={isSubmitting}
                                            onCancel={handleReset}
                                        />
                                    </fieldset>
                                </WrapperAccordion>
                            </Form>
                        )}

                    </Formik>
                ) : (
                    <div><Translation id="no_data"/></div>
                )}
            </div>
        </WrapperPageSimple>
    )
}

export default withRouter(EditNewspaper)